<template>
  <div
    class="position-relative grid-list"
    :class="{ 'grid-list-reorder': !left }"
  >
    <div v-if="mdAndUp && !left" class="item-divider">
      <img class="d-block" src="../../assets/img/partners-divider.jpg" />

      <div class="item"></div>
      <div class="item"></div>
    </div>

    <v-sheet class="position-relative item-content-img">
      <div
        class="d-flex align-center justify-center position-relative item-img"
        :class="{ 'justify-md-end': !left }"
        :style="{
          backgroundImage: `linear-gradient(0deg, #666A9E, #666A9E), url(${
            files + img + '?resize=1&w=960'
          })`,
        }"
        width="100%"
      >
        <v-col
          class="mx-auto position-relative"
          :class="{ 'mr-md-0 ml-md-auto': left, 'ml-md-0 mr-md-auto': !left }"
          cols="8"
          sm="5"
          md="8"
          lg="7"
        >
          <img
            class="d-block"
            :src="files + img_brand + '?resize=1&w=600'"
            :alt="title"
            width="100%"
          />
        </v-col>
      </div>
    </v-sheet>

    <v-sheet class="d-flex align-center item-caption">
      <v-row class="mx-0" justify="center" :justify-md="left ? 'start' : 'end'">
        <v-col
          class="px-3 px-md-0 mx-md-10"
          :class="{ 'pl-md-16': left, 'pr-md-16': !left }"
          cols="12"
          sm="10"
          lg="7"
        >
          <div
            class="
              grey--text
              text--darken-1 text-body-1 text-center text-md-left
              mt-4
              item-text
            "
            v-html="introduction"
          ></div>

          <div class="text-center text-md-left mt-4 mt-md-6">
            <ButtonWidget :to="to">Saiba Mais</ButtonWidget>
          </div>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  props: {
    img_brand: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    introduction: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      required: true,
    },
    left: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  components: {
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 0;
  grid-template-areas: "photos caption";
  grid-template-columns: 53vw 47vw;

  @media screen and (max-width: 960px) {
    grid-template-areas:
      "photos"
      "caption";
    grid-template-columns: 1fr;
  }

  .item-divider {
    height: 530px;
    left: 50%;
    margin-left: -75px;
    margin-top: -265px;
    position: absolute;
    top: 0;
    -webkit-transform: skew(-10deg);
    -moz-transform: skew(-10deg);
    -o-transform: skew(-10deg);
    transform: skew(-10deg);
    width: 150px;
    z-index: 4;

    @media screen and (max-width: 1264px) {
      height: 350px;
      margin-left: -50px;
      margin-top: -175px;
      width: 100px;
    }

    img {
      display: block;
      height: 100%;
      width: 100%;
    }

    .item {
      background-color: rgba(255, 255, 255, 0.4);
      bottom: 20px;
      position: absolute;
      left: -20px;
      top: -20px;
      right: 20px;
      z-index: -1;

      &:last-child {
        bottom: -20px;
        left: 20px;
        top: 20px;
        right: -20px;
      }
    }
  }

  .item-content-img {
    grid-area: photos;

    @media screen and (min-width: 960.001px) {
      &:before {
        background-image: url(../../assets/img/bg-partners.png);
        background-size: contain;
        background-position: left center;
        content: "";
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: rotate(180deg);
        width: 100px;
        z-index: 3;
      }

      .item-img {
        padding-right: 150px;
      }
    }
  }

  &.grid-list-reorder {
    grid-template-areas: "caption photos";
    grid-template-columns: 47vw 53vw;

    @media screen and (max-width: 960px) {
      grid-template-areas:
        "photos"
        "caption";
      grid-template-columns: 1fr;
    }

    @media screen and (min-width: 960.001px) {
      .item-content-img {
        &:before {
          background-position: left center;
          left: 0;
          right: initial;
          transform: rotate(0);
        }

        .item-img {
          padding-left: 150px;
          padding-right: 0;
        }
      }
    }
  }

  .item-img {
    aspect-ratio: 1000 / 500;
    background-blend-mode: color, normal;
    background-position: center;
    background-size: cover;
  }

  .item-caption {
    grid-area: caption;

    .item-text::v-deep {
      -webkit-box-orient: vertical;
      box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      line-clamp: 6;
      line-height: 2em !important;
      overflow: hidden;
      text-overflow: ellipsis;

      @media screen and (max-width: 1264px) {
        -webkit-line-clamp: 4;
        line-clamp: 4;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
